import { defineSagaForService, DownloadServiceConfiguration, GlobalError } from '@repo/core'
import { getGlobalPosition } from '@repo/position-services'
import { globalPositionActions, globalPositionDownloadActions } from '../../../slices'

export const globalPositionConfig = defineSagaForService({
  [globalPositionActions.getRequest.type]: {
    apiClientDomain: 'position',
    service: getGlobalPosition,
    actionTypeResponse: globalPositionActions.getResponse.type,
    actionTypeRequest: globalPositionActions.getRequest.type,
    getError: (error) =>
      error.response?.data ?? ({ errors: [{ code: error.code }] } as GlobalError),
  },
  [globalPositionActions.refreshRequest.type]: {
    apiClientDomain: 'position',
    service: getGlobalPosition,
    actionTypeResponse: globalPositionActions.refreshResponse.type,
    actionTypeRequest: globalPositionActions.refreshRequest.type,
    getError: (error) =>
      error.response?.data ?? ({ errors: [{ code: error.code }] } as GlobalError),
  },
})

export const globalPositionDownloadConfig: Record<string, DownloadServiceConfiguration> = {
  [globalPositionDownloadActions.downloadRequest.type]: {
    apiClientDomain: 'position',
    service: getGlobalPosition,
    actionTypeRequest: globalPositionDownloadActions.downloadRequest.type,
    actionTypeResponse: globalPositionDownloadActions.downloadResponse.type,
  },
}
